import { FC } from "react";
import { buildHighlightQuery, getFormattedCurrency, highlightTerms } from "../../../../../../core/helpers";
import { iMenuExample } from "../../../../../../core/models/MenuExamples";
import "./MenuExamplesItem.styles.scss";

interface iProps {
    data: iMenuExample;
    menuIncludes?: string[];
}

const MenuExamplesItem: FC<iProps> = ({ data, menuIncludes = [] }) => {
    const hasQuery = buildHighlightQuery(menuIncludes) !== '';

    const renderText = (text: string) => (hasQuery
        ? <span dangerouslySetInnerHTML={{ __html: highlightTerms(text, menuIncludes) }} />
        : <>{text}</>);

    return (
        <div className="MenuExamplesItem">
            <div className="MenuExamplesItem__header">
                <div className="MenuExamplesItem__title">{renderText(data.title)}</div>
                {!!data.price && (
                    <div className="MenuExamplesItem__price">
                        {getFormattedCurrency(data.price)}
                    </div>
                )}
            </div>
            {data.description && <div className="MenuExamplesItem__description">{renderText(data.description)}</div>}
        </div>
    );
};

export default MenuExamplesItem;
